import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "../../hooks";

import { closeMsgModal } from "../../store/MessageModalSlice";
import { dropIn } from "../../animations/MsgModalAnimations";

import Backdrop from "../Backdrop";
import IconPlus from "../IconPlus";


const MessageModal = () => {

  const location = useLocation();
  const currentLocation = useRef('');

  const dispatch = useAppDispatch();

  const { showModal, messageData } = useAppSelector(state => state.messageModal);
  const { title, description, image } = messageData;

  const closeMessage = () => {
    dispatch(closeMsgModal());
  };

  useEffect(() => {
    if(currentLocation.current !== location.pathname && showModal) dispatch(closeMsgModal());
    currentLocation.current = location.pathname;
  }, [showModal, location, dispatch]);

  return (
    <AnimatePresence
      initial={false}
      exitBeforeEnter={true}
      onExitComplete={() => null}
    >
      { showModal && <section className="relative z-1000">

        <Backdrop onClick={closeMessage}>

          <motion.div
            className="relative bg-white py-20 px-16 flex items-center rounded-2xl"
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <div onClick={closeMessage} className="absolute rotate-45 top-5 left-5 bg-gray p-1 flex items-center justify-center border rounded-full select-none">
              <IconPlus />
            </div>
            <div className="w-96 py-6">
              <h2 className="text-4xl">{ title }</h2>
              <p className="text-xl mt-4">{ description }</p>
            </div>
            { image && <div onClick={closeMessage} className="ml-8">
              <img className="select-none bg-white max-w-[200px]" src={image} alt={title} />
            </div>}
          </motion.div>

        </Backdrop>

      </section>
      }
    </AnimatePresence>
  );
};

export default MessageModal;
